export enum CaseLedgerType {
	Fee = 1,
	Payment = 2,
}

export enum CaseLedgerCategory {
	TreatmentCourt = 1,
	Other = 2,
}

export enum CaseLedgerSubcategory {
	MonthlyDues = 1,
	MonthlyPayment = 2,
}